import backend from '@common/backend';

const BASE = '/students';

export interface IGetStudentsQuery {
	search?: string;
	page?: number;
	limit?: number;
}

const studentToBE = ({ parents, ...student }: any) => ({
	...student,
	parents_ids: parents.map((parent: any) => parent.id),
});

export const getStudents = async (query: IGetStudentsQuery) =>
	backend.get(`${BASE}/`, {
		params: query,
	});

export const createStudent = async (data: any) => backend.post(`${BASE}`, data);

export const getStudent = async (id: number) => backend.get(`${BASE}/${id}`);

export const removeStudent = async (id: number) => backend.delete(`${BASE}/${id}`);

export const saveStudent = async (id: number, data: any) =>
	backend.post(`${BASE}/${id}`, studentToBE(data));

export const transferStudent = async (id: number, data: any) =>
	backend.post(`${BASE}/${id}/transfer`, data);

export const multiTransferStudent = async (id: number, data: any) =>
	backend.post(`${BASE}/${id}/transfer/bulk`, data);

export const deactivateStudentLesson = async (data: any) =>
	backend.post(`${BASE}/deactivateLesson`, data);

export const getStudentsCompletedTests = async (query: { service_id: number }) =>
	backend.get(`${BASE}/tests/completed`, {
		params: query,
	});

export const getAllStudentTests = async (query: { service_id: number }) =>
	backend.get(`${BASE}/tests/all`, {
		params: query,
	});

export const sendLessonAnalitics = async (data: {
	name: string;
	schedule_lesson_id: number;
	start_time?: string;
	end_time?: string;
}) => backend.post('/studentScheduleLessonActivities', data);
